import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Our Next-Gen Tech Stack for .Net Development
            </h3>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/language/C#.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CSharp</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/language/vb_net.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>vb.net</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frameworks">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/framework/.net_core.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>.Net core</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/framework/.net.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>.Net</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/framework/xamarin.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Xamarin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/framework/Net_Maui.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>.Net Maui</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/frontend/Angular_Js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Angular Js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/frontend/React.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>React</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/dot_net/frontend/Vue.net.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Vue Js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Web Technology">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/ASP.Net_core.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ASP.Net core</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/ASP.net_MVC.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ASP.net MVC</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/Blazor.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Blazor</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/HTML.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/css.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa///dot_net/web-tech/web_forms.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Web forms</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
